import { formatCurrency } from 'common/FormatUtilities';
import React from 'react';
import { ChipColor } from 'src/shared/design-system/Chip';
import { VerticallyCenteredText } from 'src/shared/design-system/VerticallyCenteredText';
import { match } from 'ts-pattern';
import { OrdersCardHeader, OrdersCardHeaderChip, OrdersCardPriceText } from './styles';
import { RecurringSubscription } from './utilities';

export const ConsumerSubscriptionsCardHeader: React.FC<{ subscription: RecurringSubscription }> = ({
  subscription,
}) => {
  const { orderTemplate, recurringPeriodDays } = subscription;
  const { grandTotal } = orderTemplate;

  const userFriendlyRecurringPeriod = match(recurringPeriodDays)
    .with(7, () => 'Every week')
    .with(14, () => 'Every other week')
    .otherwise((val) => `Every ${val} days`);

  const chipProps = {
    text: userFriendlyRecurringPeriod,
    color: ChipColor.EGGPLANT,
  };

  return (
    <OrdersCardHeader>
      <OrdersCardHeaderChip {...chipProps} />
      <OrdersCardPriceText>
        <VerticallyCenteredText>Est. {formatCurrency(grandTotal)}</VerticallyCenteredText>
      </OrdersCardPriceText>
    </OrdersCardHeader>
  );
};
